import _defineProperty from "/drone/src/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { useMemo } from 'react';
import { FilterNumberConditionType, FilterStringConditionType, FilterDateConditionType, FilterEnumConditionType } from '../conditionTypes';
var standardTypes = {
  number: new FilterNumberConditionType('number'),
  string: new FilterStringConditionType('string'),
  date: new FilterDateConditionType('date'),
  enum: new FilterEnumConditionType('enum')
};
export var useTypeIndex = function useTypeIndex(customTypes) {
  return useMemo(function () {
    var index = {};

    if (customTypes) {
      customTypes.forEach(function (type) {
        index[type.id] = type;
      });
    }

    return _objectSpread(_objectSpread({}, standardTypes), index);
  }, [customTypes]);
};